<template>
    <div>
        <div class="row">
          <div class="col-md-12">
              <div class="top-list-toolbar">
                  <div>
                      <h4 class="text-primary">Payment</h4>
                      <ol class="breadcrumb breadcrumb-card-header">
                          <li class="breadcrumb-item">
                          <a href="javascript:void(0);" @click="backParent">Purchasing Payment</a>
                          </li>
                          <li class="breadcrumb-item active">
                          <span v-if="payment.id === null">New</span>
                          <span v-else>
                              {{ payment.group_no }}
                          </span>
                          </li>
                      </ol>
                      <button type="button" @click="backParent" class="btn btn-sm btn-hard-outline-primary pull-left"><i class="fa fa-reply" aria-hidden="true"></i> Back</button>
                      <button class="btn btn-success btn-sm pull-left dropdown-toggle" type="button" id="sync-action" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">Action</button>
                      <div class="dropdown-menu" aria-labelledby="sync-action">
                        <a class="dropdown-item" href="javascript:void(0)" @click="approvePayment" v-show="authUser.permissions.purchasing_payment_super_admin">Approve</a>
                        <a class="dropdown-item" href="javascript:void(0)" @click="validate" >Validate</a>
                        <a class="dropdown-item" href="javascript:void(0)" @click="setJournal('reply')" v-show="payment.id !== null">Set Journal</a>
                        <a class="dropdown-item" href="javascript:void(0)" @click="print" v-show="payment.id !== null">Print</a>
                        <a class="dropdown-item" href="javascript:void(0)" @click="deletePayment" v-show="authUser.permissions.purchasing_payment_super_admin">Delete</a>
                        <a class="dropdown-item" href="javascript:void(0)" @click="unlockPayment" v-show="authUser.permissions.purchasing_payment_super_admin">Unlock</a>
                      </div>
                      <button type="button" @click="savePayment" class="btn btn-sm btn-soft-primary pull-left" v-show="payment.id === null"><i class="fa fa-check" aria-hidden="true"></i> Save</button>
                      <button type="button" @click="updatePayment" class="btn btn-sm btn-soft-primary pull-left" v-show="payment.id !== null"><i class="fa fa-check" aria-hidden="true"></i> Update</button>
                      <button type="button" class="btn btn-sm btn-warning pull-right" v-show="payment.id !== null" data-toggle="modal" data-target="#modalRequestEdit" data-backdrop="static" data-keyboard="false"><i class="fa fa-reply" aria-hidden="true"></i> Request Edit</button>
                      <button type="button" class="btn btn-sm btn-hard-outline-primary pull-right" @click="getVendorUom">GET UM</button>
                  </div>
              </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12">
            <div class="card card-list">
              <div class="card-header">
                <div class="col-md-12">
                  <h5 class="text-primary">
                    <span v-if="payment.id === null">New</span>
                    <span v-else>{{ payment.group_no }}</span>
                    <span class="badge badge-success ml-1" v-if="payment.status === 'approve'">{{ payment.status }}</span>
                    <span class="badge badge-primary ml-1" v-else>{{ payment.status }}</span>
                  </h5>
                </div>
              </div>
              <div class="card-body">
                <div class="alert alert-danger alert-dismissible fade show" role="alert" v-if="alert.length > 0">
                  <ul v-for="(a, index) in alert" :key="index">
                    <li v-html="a"></li>
                  </ul>
                </div>
                <div class="row">
                  <div class="col-md-6">
                    <dl class="row dl-custom font-12">
                        <dt class="col-md-4">Company</dt>
                        <dd class="col-md-8">
                            <select v-model="payment.company_no" class="form-control" :disabled="payment.id !== null" @change="setCompany">
                            <option v-for="c in companyList" :key="c.id" :value="c.company_no">{{ c.name }}</option>
                            </select>
                        </dd>
                        <dt class="col-md-4">Method</dt>
                        <dd class="col-md-8">
                          <select class="form-control form-control-lite" v-model="payment.method_id" @change="setMethod" :disabled="payment.lock">
                            <option v-for="m in methodList" :key="m.id" :value="m.id">{{ m.name }}</option>
                          </select>
                        </dd>
                        <dt class="col-md-4">Create Date</dt>
                        <dd class="col-md-8">
                            <span v-if="authUser.permissions.sale_backdate">
                              <span v-if="payment.lock === true">{{ payment.payment_date | dateFormat('DD/MM/YYYY') }}</span>
                              <datetime v-else v-model="payment.payment_date" format="dd/MM/yyyy" class="form-control form-control-lite" value-zone="local" zone="local"></datetime>
                            </span>
                            <span v-else>
                              <span v-if="payment.lock === true">{{ payment.payment_date | dateFormat('DD/MM/YYYY') }}</span>
                              <datetime v-else v-model="payment.payment_date" format="dd/MM/yyyy" class="form-control form-control-lite" value-zone="local" zone="local" @input="checkDate"></datetime>
                            </span>
                        </dd>

                        <dt class="col-md-4" v-if="payment.method_id ===3">Finish date</dt>
                        <dd class="col-md-6" v-if="payment.method_id ===3">
                          <span v-if="payment.lock === true">{{ payment.finish_date | dateFormat('DD/MM/YYYY') }}</span>
                          <datetime v-else v-model="payment.finish_date" format="dd/MM/yyyy" class="form-control form-control-lite" value-zone="local" zone="local"></datetime>
                        </dd>
                        <dd class="col-md-2" v-if="payment.method_id ===3">
                          <div class="custom-control custom-checkbox">
                            <input type="checkbox" id="canBarcode" data-parsley-multiple="groups" data-parsley-mincheck="2" class="custom-control-input" v-model="payment.finish" @input="resetFinish">
                            <label for="canBarcode" class="custom-control-label">&nbsp;</label>
                          </div>
                        </dd>

                        <dt class="col-md-4" v-if="payment.method_id ===3">Giro No.</dt>
                        <dd class="col-md-8" v-if="payment.method_id ===3">
                          <span v-if="payment.lock === true">{{ payment.giro_no }}</span>
                          <input v-else type="text" class="form-control form-control-lite" v-model="payment.giro_no" />
                        </dd>

                        <dt class="col-md-4" v-if="payment.method_id ===3">Bank</dt>
                        <dd class="col-md-8" v-if="payment.method_id ===3">
                          <select v-model="payment.bank_id" class="form-control" :disabled="payment.lock">
                            <option v-for="b in bankList" :key="b.id" :value="b.id">{{ b.name }}</option>
                          </select>
                        </dd>

                        <dt class="col-md-4" v-if="payment.method_id ===3">Bank Name</dt>
                        <dd class="col-md-8" v-if="payment.method_id ===3">
                          <span v-if="payment.lock === true">{{ payment.bank_name }}</span>
                          <input v-else type="text" class="form-control form-control-lite" v-model="payment.bank_name" />
                        </dd>
                    </dl>
                  </div>
                  <div class="col-md-6">
                    <dl class="row dl-custom">
                      <dt class="col-md-4">Amount</dt>
                      <dd class="col-md-8">
                          <span v-if="payment.lock == true">{{ payment.total | currency }}</span>
                          <input v-else class="form-control form-control-lite" type="text" v-model="payment.total" v-money="money" :disabled="payment.lock"/>
                      </dd>

                      <dt class="col-md-4">Account</dt>
                      <dd class="col-md-8">
                          <v-select class="vsc-custom" :options="accountSelect" :reduce="account => account.meta.code" label="account" v-model="payment.account_code" :disabled="payment.lock"/>
                      </dd>

                      <dt class="col-md-4">Vendor</dt>
                      <dd class="col-md-6">
                        <v-select class="vsc-custom" :options="vendorSelect" :reduce="vendor => vendor.meta.code" label="vendor" v-model="payment.vendor_no" :disabled="payment.lock"/>
                      </dd>
                      <dd class="col-md-2" v-if="payment.method_id !== 4">
                        <button type="button" class="btn btn-sm btn-hard-primary" @click="searchVendor" :disabled="payment.lock" data-toggle="modal" data-target="#modalPurchasingPaymentGroup" data-backdrop="static" data-keyboard="false" ><i class="fa fa-search"></i></button>
                      </dd>

                      <dt class="col-md-4">Uang Muka</dt>
                      <dd class="col-md-6">{{ totalUM | currency}}</dd>

                      <dt class="col-md-4">Journal Manual?</dt>
                      <dd class="col-md-6">
                        <div class="custom-control custom-checkbox">
                          <input type="checkbox" id="canBarcode" data-parsley-multiple="groups" data-parsley-mincheck="2" class="custom-control-input" v-model="payment.manual_journal">
                          <label for="canBarcode" class="custom-control-label">&nbsp;</label>
                        </div>
                      </dd>
                    </dl>
                  </div>
                </div>
                <hr>
                <div class="row">
                  <div class="col-md-12">
                    <ul class="nav nav-tabs nav-bordered">
                      <li class="nav-item"><a href="#payment" data-toggle="tab" aria-expanded="false" class="nav-link active">Payment</a></li>
                      <li class="nav-item"><a href="#journal" data-toggle="tab" aria-expanded="false" class="nav-link">Journal</a></li>
                      <li class="nav-item"><a href="#um-data" data-toggle="tab" aria-expanded="false" class="nav-link">Uang Muka</a></li>
                    </ul>
                    <div class="tab-content">
                      <div class="tab-pane active" id="payment">
                        <div class="row">
                          <div class="col-md-12">
                            <div class="table-responsive">
                              <table class="table table-item table-sm table-hover table-striped">
                                  <thead>
                                      <th>Tgl.</th>
                                      <th>Payment No</th>
                                      <th>Notes</th>
                                      <th>Amount</th>
                                      <th class="text-right">#</th>
                                  </thead>
                                  <tbody>
                                      <tr v-for="(p, index) in payment.purchasings" :key="p.id">
                                          <td>{{ p.payment_date | dateFormat('DD/MM/YYYY') }}</td>
                                          <td>{{ p.payment_no }}</td>
                                          <td><input type="text" v-model="p.notes" class="form-control" :disabled="payment.lock" /></td>
                                          <td><input type="text" v-model="p.price" class="form-control form-control-right" v-money="money2" :disabled="payment.lock"/></td>
                                          <td class="text-right">
                                              <button type="button" class="btn btn-sm btn-soft-outline-danger" @click="removePaymentPurchasing(index)" :disabled="payment.lock"><i class="fa fa-trash"></i></button>
                                          </td>

                                      </tr>
                                      <tr>
                                          <td></td>
                                          <td></td>
                                          <td class="text-right"><b>Subtotal:</b></td>
                                          <td class="text-right"><b>{{ totalProcessPayment | currency }}</b></td>
                                          <td></td>
                                      </tr>
                                      <tr>
                                        <td></td>
                                        <td></td>
                                        <td class="text-right"><b>Uang Muka:</b></td>
                                        <td class="text-right"><b>{{ totalUM | currency }}</b></td>
                                        <td></td>
                                      </tr>
                                      <tr>
                                        <td></td>
                                        <td></td>
                                        <td class="text-right"><b>Discount:</b></td>
                                        <td class="text-right">
                                          <input type="text" v-model="payment.discount" v-money="money" class="form-control form-control-right" @input="calcTotal"/>
                                        </td>
                                        <td></td>
                                      </tr>
                                      <tr>
                                        <td></td>
                                        <td></td>
                                        <td class="text-right">Total:</td>
                                        <td class="text-right">{{ totalPayment | currency }}</td>
                                        <td></td>
                                      </tr>
                                      <tr>
                                        <td></td>
                                        <td></td>
                                        <td class="text-right"><b>Total Bayar:</b></td>
                                        <td class="text-right">{{ this.payment.total }}</td>
                                        <td></td>
                                      </tr>
                                      <tr>
                                        <td></td>
                                        <td></td>
                                        <td class="text-right"><b>Rounding:</b></td>
                                        <td class="text-right">{{ totalRounding | currency }}</td>
                                        <td></td>
                                      </tr>
                                  </tbody>
                              </table>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="tab-pane" id="journal">
                        <div class="table-responsive">
                          <table class="table table-sm table-item table-hover table-striped">
                            <thead>
                              <th>Journal Code</th>
                              <th>Date</th>
                              <th>Account Code</th>
                              <th>Remark</th>
                              <th class="text-right">Debit</th>
                              <th class="text-right">Credit</th>
                            </thead>
                            <tbody>
                              <tr v-for="j in payment.journals" :key="j.id">
                                <td>
                                  <span v-if="j.level === 1">
                                    <b>{{ j.journal_code }} - {{ j.journal_description }}</b>&nbsp;
                                    <span class="badge badge-success" v-if="j.status === 'posted'">{{ j.status }}</span>
                                    <span class="badge badge-warning" v-else-if="j.status === 'draft'">{{ j.status }}</span>
                                  </span>
                                  <span v-else></span>
                                </td>
                                <td>{{ j.journal_date | dateFormat('DD/MM/YYYY') }}</td>
                                <td><b>{{ j.account_code }} {{ j.account }}</b></td>
                                <td>{{ j.remark }}</td>
                                <td class="text-right">
                                  <span v-if="j.level === 2">{{ j.debit | currency }}</span>
                                  <span v-if="j.level === 3"><b>{{ j.debit | currency }}</b></span>
                                  <span v-else></span>
                                </td>
                                <td class="text-right">
                                  <span v-if="j.level === 2">{{ j.credit | currency }}</span>
                                  <span v-if="j.level === 3"><b>{{ j.credit | currency }}</b></span>
                                  <span v-else></span>
                                </td>
                              </tr>
                            </tbody>
                          </table>
                          <button type="button" class="btn btn-sm btn-success pull-right" @click="postJournal">Post</button>
                        </div>
                      </div>
                      <div class="tab-pane" id="um-data">
                        <div class="row">
                          <div class="col-md-12">
                            <div class="table-responsive">
                              <button class="btn btn-sm btn-hard-primary" @click="getVendorUom">Get UM</button>
                              <table class="table table-sm table-item table-hover table-striped">
                                <thead>
                                  <th>Status</th>
                                  <th>Method</th>
                                  <th>Payment No</th>
                                  <th>Create Date</th>
                                  <th>Vendor</th>
                                  <th>Ref No.</th>
                                  <th class="text-right">Total</th>
                                  <th>#</th>
                                </thead>
                                <tbody>
                                  <tr v-if="payment.refs.length == 0">
                                    <td colspan="7">
                                      <i>No Data</i>
                                    </td>
                                  </tr>
                                  <tr v-for="(r, index) in payment.refs" :key="r.id">
                                    <td>{{ r.status }}</td>
                                    <td>{{ r.method_id }}</td>
                                    <td>{{ r.group_no }}</td>
                                    <td>{{ r.payment_date | dateFormat('DD/MM/YYYY') }}</td>
                                    <td>{{ r.vendor }}</td>
                                    <td>{{ r.ref_no }}</td>
                                    <td class="text-right">{{ r.total | currency }}</td>
                                    <td>
                                      <button type="button" class="btn btn-sm btn-outline-danger" @click="removeRefs(index)"><i class="fa fa-trash"></i></button>
                                    </td>
                                  </tr>
                                </tbody>
                              </table>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <SalesRequestModal @getRequestEdit='requestEdit'/>
        <SalePaymentGroupModal @processPayment="processPayment" @processPaymentVendor="processPaymentVendor"/>
        <!-- <pre>{{ payment.purchasings }}</pre> -->
    </div>
</template>
<script>
import Axios from 'axios'
import { mapState } from 'vuex'
import SalesRequestModal from '@/components/sales/SalesRequestModal.vue'
import SalePaymentGroupModal from '@/components/payment/SalePaymentGroupModal.vue'
import { getHeader, paymentUrl, lockUrl, journalUrl, salesUrl, sale2Url, purchasingUrl } from '../../config'

export default {
  name: 'PurchasingPaymentGroupForm',
  props: ['payment'],
  components: {
    SalesRequestModal,
    SalePaymentGroupModal
  },
  data () {
    return {
      alert: [],
      selectAll: false,
      selected: [],
      paymentData: {},
      dataRaw: [{
        id: 1,
        sale_no: null,
        sale_date: null,
        sale_due_date: null,
        ref_no: null,
        branch_no: null,
        vendor_no: null,
        vendor: null,
        subtotal: '0',
        tax_id: null,
        tax: '0',
        taxes: null,
        discount: 0,
        total: '0',
        payment_total: '0',
        outstanding: '0',
        delivery_cost: '0',
        deliver_no: null,
        status: null,
        type_id: null,
        lock: false,
        company_no: null,
        term_due_id: null,
        ext_no: null,
        sp_no: null,
        discount_percentage: null,
        schedule_payment_date: null
      }],
      money: {
        decimal: ',',
        thousands: '.',
        prefix: '',
        suffix: '',
        precision: 0,
        masked: true /* doesn't work with directive */
      },
      money2: {
        decimal: ',',
        thousands: '.',
        prefix: '',
        suffix: '',
        precision: 2,
        masked: true /* doesn't work with directive */
      }
    }
  },
  computed: {
    ...mapState({
      customerList: state => state.customers.customerList,
      typeList: state => state.payments.typeList,
      methodList: state => state.payments.methodList,
      chartOfAccountList: state => state.accounts.chartOfAccountList,
      authUser: state => state.users.authUser,
      companyList: state => state.companies.companyList,
      vendorList: state => state.vendors.vendorList,
      vendorOutstandingList: state => state.vendors.vendorOutstandingList
    }),
    totalUM () {
      var sum = 0
      var array = this.payment.refs
      for (let i = 0; i < array.length; i++) {
        console.log('total refs: ' + array[i].total)
        sum += parseFloat(array[i].total)
      }
      return sum
    },
    totalOustandingPayment () {
      var payment = 0
      payment = this.totalProcessPayment
      return payment
    },
    totalPayment () {
      var discount = parseFloat(this.payment.discount.replace(/\./g, ''))
      var total = 0
      total = this.totalProcessPayment - this.totalUM - discount
      return total
    },
    totalRounding () {
      var totalPayment = parseFloat(this.payment.total.replace(/\./g, ''))
      var round = 0
      if (this.payment.method_id !== 4) {
        round = totalPayment - this.totalPayment
      }
      return round
    },
    totalSalePaymentOutstanding () {
      var sum = 0
      var array = this.dataRaw
      for (let i = 0; i < array.length; i++) {
        sum += parseFloat(array[i].outstanding)
      }
      return sum
    },
    totalProcessPayment () {
      var sum = 0
      var array = this.payment.purchasings
      for (let i = 0; i < array.length; i++) {
        var price = array[i].price.replace(/\./g, '')
        price = price.replace(',', '.')
        console.log(price)
        sum += parseFloat(price)
      }
      return sum
    },
    totalProcessPaymentVendor () {
      var sum = 0
      var array = this.payment.purchasings
      for (let i = 0; i < array.length; i++) {
        sum += parseFloat(array[i].price.toString().replace(/\./g, ''))
      }
      return sum
    },
    customerSelect () {
      var loop = []
      var array = this.customerList
      for (let i = 0; i < array.length; i++) {
        var obj = {
          customer: array[i].customer_no + ' - ' + array[i].name,
          meta: {
            code: array[i].customer_no
          }
        }
        loop.push(obj)
      }
      return loop
    },
    vendorSelect () {
      var loop = []
      var array = this.vendorList
      for (let i = 0; i < array.length; i++) {
        var obj = {
          vendor: array[i].vendor_no + ' - ' + array[i].name,
          meta: {
            code: array[i].vendor_no
          }
        }
        loop.push(obj)
      }
      return loop
    },
    accountSelectCheck () {
      var account = this.chartOfAccountList.filter(d => d.company_no === this.payment.company_no)
      return account
    },
    accountSelect () {
      var loop = []
      var array = []
      var methodID = this.payment.method_id === null || this.payment.method_id === '' ? 1 : this.payment.method_id
      if (methodID === 1) {
        array = this.accountSelectCheck
      } else {
        array = this.accountSelectCheck
      }
      console.log(array)
      for (let i = 0; i < array.length; i++) {
        var obj = {
          account: array[i].code + ' - ' + array[i].name,
          meta: {
            code: array[i].code
          }
        }
        loop.push(obj)
      }
      return loop
    }
  },
  methods: {
    async unlockPayment () {
      await this.$swal.fire({
        title: 'Are you sure to unlock?',
        text: "You won't be able to revert this!",
        icon: 'error',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes, unlock it!'
      }).then((result) => {
        if (result.value) {
          Axios.post(paymentUrl + '/unlock', { id: this.payment.id }, { headers: getHeader(), timeout: process.env.VUE_APP_TIMEOUT })
            .then(response => {
              this.payment.lock = false
            })
            .catch(error => {
              console.log(error.response)
              this.$swal('Error', error.response.data.message, 'error')
              throw error
            })
        }
      })
    },
    async validate () {
      this.alert = []
      if (this.payment.method_id == null) {
        this.alert.push('<b>Method</b> harus diinput terlebih dahulu')
      }
      if (this.payment.method_id !== 4) {
        var amount = parseFloat(this.payment.total.replace(/\./g, ''))
        if (amount < 1) {
          if (this.totalUM > 0) {
          } else {
            this.alert.push('<b>Amount</b> harus diinput terlebih dahulu (tidak boleh kosong)')
          }
        }
      }
      if (this.payment.account_code == null) {
        this.alert.push('<b>Account</b> harus diinput terlebih dahulu')
      }
      if (this.payment.vendor_no == null) {
        this.alert.push('<b>Vendor</b> harus diinput terlebih dahulu')
      }
      // if (this.payment.method_id !== 4) {
      //   if (parseFloat(this.totalPayment) <= 0) {
      //     this.alert.push('<b>Pembelian</b> masih belum dipilih')
      //   }
      // }
    },
    async checkDate () {
      var date1 = new Date()
      date1.setHours(0, 0, 0, 0)
      var date2 = new Date(this.payment.payment_date)
      date2.setHours(0, 0, 0, 0)
      var remaining = date2.getTime() - date1.getTime()
      var diffInDay = remaining / (1000 * 3600 * 24)
      console.log('Diff in a day ' + diffInDay)
      if (diffInDay > 0) {
        this.$swal('Error', 'Tanggal tidak boleh lebih dari hari ini (' + diffInDay + ' hari)', 'error')
        this.payment.payment_date = date1.toISOString()
      } else if (Math.abs(diffInDay) > 2) {
        this.$swal('Error', 'Tanggal tidak boleh kurang dari 2 hari', 'error')
        this.payment.payment_date = date1.toISOString()
      }
    },
    async voidPayment () {
      this.$Progress.start()
      this.loader.isLoading = true
      var obj = {
        id: this.payment.id
      }
      await Axios.post(paymentUrl + '/void', obj, { headers: getHeader(), timeout: process.env.VUE_APP_TIMEOUT })
        .then(response => {
          console.log(response.data.message)
          this.$Progress.finish()
          this.loader.isLoading = false
          this.$swal('Success', response.data.message, 'success')
          this.backParent()
        })
        .catch(error => {
          console.log(error)
          console.log(error.response)
          this.$Progress.finish()
          this.loader.isLoading = false
          this.$swal('Error', error.response.data.message, 'error')
          throw error
        })
    },
    async resetFinish () {
      if (this.payment.finish === true) {
        this.payment.finish_date = null
      }
    },
    async removeRefs (index) {
      var ref = this.payment.refs[index]
      ref.ref_no = null
      this.payment.refs.splice(index, 1)
    },
    async deletePayment () {
      await this.$swal.fire({
        title: 'Are you sure Delete this?',
        text: "You won't be able to revert this!",
        icon: 'error',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes, delete it!'
      }).then((result) => {
        if (result.value) {
          console.log(paymentUrl + '/' + this.payment.id)
          Axios.delete(paymentUrl + '/' + this.payment.id, { headers: getHeader(), timeout: process.env.VUE_APP_TIMEOUT })
            .then(response => {
              this.$emit('backSaveClicked')
            })
            .catch(error => {
              console.log(error.response)
              this.$swal('Error', error.response.data.message, 'error')
              throw error
            })
        }
      })
    },
    async getVendorUom () {
      this.payment.refs = []
      var obj = {
        vendor_no: this.payment.vendor_no
      }
      await Axios.post(paymentUrl + '/get-um-vendor', obj, { headers: getHeader(), timeout: process.env.VUE_APP_TIMEOUT })
        .then(response => {
          console.log(response.data.message)
          console.log(response.data.data)
          var array = response.data.data
          for (let i = 0; i < array.length; i++) {
            var obj = {
              id: array[i].id,
              group_no: array[i].group_no,
              prepayment_date: array[i].prepayment_date,
              payment_date: array[i].payment_date,
              category: array[i].category,
              total: array[i].total,
              method_id: array[i].method_id,
              type_id: array[i].type_id,
              bank_id: array[i].bank_id,
              account_code: array[i].account_code,
              notes: array[i].notes,
              vendor_no: array[i].vendor_no,
              vendor: array[i].vendor,
              customer_no: array[i].customer_no,
              branch_no: array[i].branch_no,
              company_no: array[i].company_no,
              status: array[i].status,
              lock: array[i].lock,
              subtotal: array[i].subtotal,
              round: array[i].round,
              penalty_amount: array[i].penalty_amount,
              discount_percentage: array[i].discount_percentage,
              discount: array[i].discount,
              finish_date: array[i].finish_date,
              giro_no: array[i].giro_no,
              bank_name: array[i].bank_name,
              report_no: array[i].report_no,
              ref_no: this.payment.payment_no
            }
            this.payment.refs.push(obj)
          }
        })
        .catch(error => {
          console.log(error)
          console.log(error.response)
          this.$swal('Error', error.response.data.message, 'error')
          throw error
        })
    },
    calcPaymentTotal () {
      var payment = this.totalProcessPayment - this.totalProcessPaymentVendor
      this.payment.total = payment.toString()
    },
    setCompany () {
      this.payment.account_code = null
      this.payment.method_id = null
    },
    calcTotal () {
      var discount = this.payment.discount.replace(/\./g, '')
      var total = parseFloat(this.totalProcessPayment) - parseFloat(discount)
      console.log(total)
    },
    processPayment (value) {
      console.log(value)
      this.getVendorUom()
      var array = value
      for (let i = 0; i < array.length; i++) {
        var obj = {
          payment_no: null,
          sale_no: array[i].sale_no,
          payment_date: this.payment_date,
          price: array[i].outstanding,
          method_id: this.payment.method_id,
          type_id: this.payment.type_id,
          bank_id: this.payment.bank_id,
          notes: this.payment.notes,
          prepayment_date: this.payment.prepayment_date,
          group_no: this.payment.group_no,
          account_code: this.payment.account_code,
          lock: false
        }
        this.payment.sales.push(obj)
      }
      this.calcPaymentTotal()
    },
    processPaymentVendor (value) {
      var array = value
      console.log(value)
      this.getVendorUom()
      for (let i = 0; i < array.length; i++) {
        var obj = {
          payment_no: null,
          purchasing_no: array[i].purchasing_no,
          payment_date: this.payment_date,
          price: array[i].outstanding,
          method_id: this.payment.method_id,
          type_id: this.payment.type_id,
          bank_id: this.payment.bank_id,
          notes: this.payment.notes,
          prepayment_date: this.payment.prepayment_date,
          group_no: this.payment.group_no,
          account_code: this.payment.account_code,
          lock: false
        }
        this.payment.purchasings.push(obj)
      }
      this.calcPaymentTotal()
    },
    async postJournal () {
      var array = this.payment.journals.filter(d => d.level === 1)
      for (let i = 0; i < array.length; i++) {
        var data = {
          id: array[i].id
        }
        await Axios.post(journalUrl + '/posting', data, { headers: getHeader(), timeout: process.env.VUE_APP_TIMEOUT })
          .then(response => {
          })
          .catch(error => {
            console.log(error.response)
            this.$swal('Error', error.response.data.message, 'error')
            return false
          })
      }
      await this.$swal('Success', 'Success Post All Journal', 'success')
      await this.$emit('backClickID', this.payment.id)
    },
    async requestEdit (value) {
      var obj = {
        request_by: this.authUser.username,
        lock_no: this.payment.group_no,
        lock_note: value,
        type: 'payment-sales'
      }
      await Axios.post(lockUrl, obj, { headers: getHeader(), timeout: process.env.VUE_APP_TIMEOUT })
        .then(response => {
          this.$swal('Lock', 'Sales has been requested', 'success')
          this.$emit('backSaveClicked')
        })
        .catch(error => {
          console.log(error)
        })
    },
    async removePaymentSales (index) {
      var sales = this.payment.purchasings[index]
      if (typeof sales.id === 'undefined') {
        this.payment.sales.splice(index, 1)
      } else {
        await this.$swal.fire({
          title: 'Are you sure Delete this?',
          text: "You won't be able to revert this!",
          icon: 'error',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: 'Yes, delete it!'
        }).then((result) => {
          if (result.value) {
            Axios.delete(salesUrl + '/payment/' + sales.id, { headers: getHeader(), timeout: process.env.VUE_APP_TIMEOUT })
              .then(response => {
                console.log(response.data.message)
                this.payment.sales.splice(index, 1)
              })
              .catch(error => {
                console.log(error.response)
                this.$swal('Error', error.response.data.message, 'error')
                throw error
              })
          }
        })
      }
      await this.calcPaymentTotal()
    },
    async removePaymentPurchasing (index) {
      var po = this.payment.purchasings[index]
      if (typeof po.id === 'undefined') {
        this.payment.purchasings.splice(index, 1)
      } else {
        await this.$swal.fire({
          title: 'Are you sure Delete this?',
          text: "You won't be able to revert this!",
          icon: 'error',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: 'Yes, delete it!'
        }).then((result) => {
          if (result.value) {
            Axios.delete(purchasingUrl + '/payment/' + po.id, { headers: getHeader(), timeout: process.env.VUE_APP_TIMEOUT })
              .then(response => {
                console.log(response.data.message)
                this.payment.purchasings.splice(index, 1)
              })
              .catch(error => {
                console.log(error.response)
                this.$swal('Error', error.response.data.message, 'error')
                throw error
              })
          }
        })
      }
      await this.calcPaymentTotal()
    },
    async setJournal (status) {
      var data = {
        id: this.payment.id
      }
      var type = this.payment.method_id
      if (type === 4) {
        console.log(paymentUrl + '/journal-purchasing-um')
        await Axios.post(paymentUrl + '/journal-purchasing-um', data, { headers: getHeader(), timeout: process.env.VUE_APP_TIMEOUT })
          .then(response => {
            if (status === 'reply') {
              this.$swal('Success', response.data.message, 'success')
              this.$emit('backSaveClicked')
            }
          })
          .catch(error => {
            console.log(error.response)
            this.$swal('Error', error.response.data.message, 'error')
          })
      } else {
        await Axios.post(paymentUrl + '/journal-purchasing', data, { headers: getHeader(), timeout: process.env.VUE_APP_TIMEOUT })
          .then(response => {
            if (status === 'reply') {
              this.$swal('Success', response.data.message, 'success')
              this.$emit('backSaveClicked')
            }
          })
          .catch(error => {
            console.log(error.response)
            this.$swal('Error', error.response.data.message, 'error')
          })
      }
    },
    async approvePayment () {
      if (this.authUser.permissions.purchasing_payment_create_admin === false) {
        await this.validate()
        if (this.alert.length > 0) {
          await window.scrollTo(0, 0)
          await this.$swal('Validation', 'Data Payment Belum valid, cek inputan terlebih dahulu', 'error')
          return false
        }
      }
      var data = {
        group_no: this.payment.group_no
      }
      await this.updatePayment()
      var message = {
        error: false,
        message: null
      }
      await Axios.post(paymentUrl + '/approve', data, { headers: getHeader(), timeout: process.env.VUE_APP_TIMEOUT })
        .then(response => {
          message.error = false
          message.message = response.data.message
        })
        .catch(error => {
          console.log(error.response)
          message.error = true
          message.message = error.response.data.message
          return false
        })
      await this.setJournal('noreply')
      if (message.error === false) {
        this.$swal('Success', message.message, 'success')
      } else {
        this.$swal('Error', message.message, 'error')
      }
      await this.$emit('backSaveClicked')
    },
    async updatePayment () {
      if (this.authUser.permissions.purchasing_payment_create_admin === false) {
        await this.validate()
        if (this.alert.length > 0) {
          await window.scrollTo(0, 0)
          await this.$swal('Validation', 'Data Payment Belum valid, cek inputan terlebih dahulu', 'error')
          return false
        }
      }
      var pdata = []
      var array = this.payment.sales
      for (let i = 0; i < array.length; i++) {
        var obj = {}
        if (typeof array[i].id === 'undefined') {
          obj = {
            payment_no: array[i].payment_no,
            sale_no: array[i].sale_no,
            payment_date: array[i].payment_date,
            price: array[i].price.replace(/\./g, ''),
            method_id: this.payment.method_id,
            type_id: this.payment.type_id,
            bank_id: array[i].bank_id,
            notes: array[i].notes,
            lock: array[i].lock,
            status: array[i].status,
            journal_code: array[i].journal_code,
            prepayment_date: array[i].prepayment_date,
            group_no: array[i].group_no,
            account_code: this.payment.account_code
          }
        } else {
          obj = {
            id: array[i].id,
            payment_no: array[i].payment_no,
            sale_no: array[i].sale_no,
            payment_date: array[i].payment_date,
            price: array[i].price.replace(/\./g, ''),
            method_id: this.payment.method_id,
            type_id: this.payment.type_id,
            bank_id: array[i].bank_id,
            notes: array[i].notes,
            lock: array[i].lock,
            status: array[i].status,
            journal_code: array[i].journal_code,
            prepayment_date: array[i].prepayment_date,
            group_no: array[i].group_no,
            account_code: this.payment.account_code
          }
        }
        pdata.push(obj)
      }
      var purchase = []
      var arr = this.payment.purchasings
      for (let i = 0; i < arr.length; i++) {
        var price = arr[i].price.replace(/\./g, '')
        price = price.replace(',', '.')
        var ob = {}
        if (typeof arr[i].id === 'undefined') {
          console.log(arr[i])
          ob = {
            payment_no: arr[i].payment_no,
            purchasing_no: arr[i].purchasing_no,
            payment_date: arr[i].payment_date,
            price: price,
            method_id: this.payment.method_id,
            type_id: this.payment.type_id,
            bank_id: arr[i].bank_id,
            notes: arr[i].notes,
            lock: arr[i].lock,
            status: arr[i].status,
            journal_code: arr[i].journal_code,
            prepayment_date: arr[i].prepayment_date,
            group_no: arr[i].group_no,
            account_code: this.payment.account_code
          }
        } else {
          ob = {
            id: arr[i].id,
            payment_no: arr[i].payment_no,
            purchasing_no: arr[i].purchasing_no,
            payment_date: arr[i].payment_date,
            price: price,
            method_id: this.payment.method_id,
            type_id: this.payment.type_id,
            bank_id: arr[i].bank_id,
            notes: arr[i].notes,
            lock: arr[i].lock,
            status: arr[i].status,
            journal_code: arr[i].journal_code,
            prepayment_date: arr[i].prepayment_date,
            group_no: arr[i].group_no,
            account_code: this.payment.account_code
          }
        }
        purchase.push(ob)
      }
      var paymentDiscount = parseFloat(this.payment.discount.replace(/\./g, ''))
      var paymentDiscountPercentage = 0
      if (paymentDiscount !== 0) {
        paymentDiscountPercentage = (paymentDiscountPercentage / this.totalProcessPayment) * 100
      }
      var createDate = this.payment.payment_date
      var finishDate = this.payment.finish_date
      if (this.payment.method_id !== 3) {
        finishDate = this.payment.payment_date
      }
      this.paymentData = {
        id: this.payment.id,
        group_no: this.payment.group_no,
        prepayment_date: this.payment.prepayment_date,
        finish_date: finishDate,
        payment_date: createDate,
        category: this.payment.category,
        total: this.payment.total.replace(/\./g, ''),
        method_id: this.payment.method_id,
        type_id: this.payment.type_id,
        bank_id: this.payment.bank_id,
        account_code: this.payment.account_code,
        notes: this.payment.notes,
        vendor_no: this.payment.vendor_no,
        customer_no: this.payment.customer_no,
        branch_no: this.authUser.branch_no,
        company_no: this.authUser.company_no,
        status: this.payment.status,
        subtotal: this.totalProcessPayment,
        discount: paymentDiscount,
        discount_percentage: paymentDiscountPercentage,
        round: this.totalRounding,
        penalty_amount: this.payment.penalty_amount,
        lock: this.payment.lock,
        giro_no: this.payment.giro_no,
        bank_name: this.payment.bank_name,
        sales: pdata,
        purchasings: purchase,
        refs: this.payment.refs,
        finish: this.payment.finish,
        manual_journal: this.payment.manual_journal
      }
      await Axios.put(paymentUrl + '/' + this.payment.id, this.paymentData, { headers: getHeader(), timeout: process.env.VUE_APP_TIMEOUT })
        .then(response => {
          this.$swal('Success', response.data.message, 'success')
          this.$emit('backSaveClicked')
        })
        .catch(error => {
          console.log(error.response)
          this.$swal('Error', error.response.data.message, 'error')
        })
    },
    async savePayment () {
      if (this.authUser.permissions.purchasing_payment_create_admin === false) {
        await this.validate()
        if (this.alert.length > 0) {
          await window.scrollTo(0, 0)
          await this.$swal('Validation', 'Data Payment Belum valid, cek inputan terlebih dahulu', 'error')
          return false
        }
      }
      var pdata = []
      var purchase = []
      var arr = this.payment.purchasings
      for (let i = 0; i < arr.length; i++) {
        var price = arr[i].price.replace(/\./g, '')
        price = price.replace(',', '.')
        var ob = {}
        if (typeof arr[i].id === 'undefined') {
          ob = {
            payment_no: arr[i].payment_no,
            purchasing_no: arr[i].purchasing_no,
            payment_date: arr[i].payment_date,
            price: price,
            method_id: this.payment.method_id,
            type_id: this.payment.type_id,
            bank_id: arr[i].bank_id,
            notes: arr[i].notes,
            lock: arr[i].lock,
            status: arr[i].status,
            journal_code: arr[i].journal_code,
            prepayment_date: arr[i].prepayment_date,
            group_no: arr[i].group_no,
            account_code: this.payment.account_code
          }
        } else {
          ob = {
            id: arr[i].id,
            payment_no: arr[i].payment_no,
            purchasing_no: arr[i].purchasing_no,
            payment_date: arr[i].payment_date,
            price: price,
            method_id: this.payment.method_id,
            type_id: this.payment.type_id,
            bank_id: arr[i].bank_id,
            notes: arr[i].notes,
            lock: arr[i].lock,
            status: arr[i].status,
            journal_code: arr[i].journal_code,
            prepayment_date: arr[i].prepayment_date,
            group_no: arr[i].group_no,
            account_code: this.payment.account_code
          }
        }
        purchase.push(ob)
      }
      var paymentDiscount = parseFloat(this.payment.discount.replace(/\./g, ''))
      var paymentDiscountPercentage = 0
      if (paymentDiscount !== 0) {
        paymentDiscountPercentage = (paymentDiscountPercentage / this.totalProcessPayment) * 100
      }
      var createDate = this.payment.payment_date
      var finishDate = this.payment.finish_date
      if (this.payment.method_id !== 3) {
        finishDate = this.payment.payment_date
      }
      this.paymentData = {
        id: null,
        group_no: null,
        prepayment_date: this.payment.prepayment_date,
        finish_date: finishDate,
        payment_date: createDate,
        category: this.payment.category,
        subtotal: this.totalProcessPayment,
        round: this.totalRounding,
        penalty_amount: this.payment.penalty_amount,
        discount: paymentDiscount,
        discount_percentage: paymentDiscountPercentage,
        total: this.payment.total.replace(/\./g, ''),
        method_id: this.payment.method_id,
        type_id: this.payment.type_id,
        bank_id: this.payment.bank_id,
        account_code: this.payment.account_code,
        notes: this.payment.notes,
        vendor_no: this.payment.vendor_no,
        customer_no: this.payment.customer_no,
        branch_no: this.payment.branch_no,
        company_no: this.payment.company_no,
        status: this.payment.status,
        lock: this.payment.lock,
        giro_no: this.payment.giro_no,
        bank_name: this.payment.bank_name,
        sales: pdata,
        purchasings: purchase,
        refs: this.payment.refs,
        finish: this.payment.finish,
        manual_journal: this.payment.manual_journal
      }
      console.log(this.paymentData)
      await Axios.post(paymentUrl, this.paymentData, { headers: getHeader(), timeout: process.env.VUE_APP_TIMEOUT })
        .then(response => {
          this.$swal('Success', response.data.message, 'success')
          this.$emit('backSaveClicked')
        })
        .catch(error => {
          console.log(error.response)
          this.$swal('Error', error.response.data.message, 'error')
        })
    },
    async selectAllSales () {
      if (this.selectAll === false) {
        var array = this.dataRaw
        for (let i = 0; i < array.length; i++) {
          this.selected.push(array[i].id)
          this.setData(i)
        }
      } else {
        this.selected = []
        this.payment.sales = []
      }
    },
    async setData (index) {
      var data = this.dataRaw[index]
      var sales = this.payment.sales.find(d => d.sale_no === data.sale_no)
      var price = 0
      //  var salesIndex = this.payment.sales.findIndex(d => d.sale_no === data.sale_no)
      var obj = {}
      if (sales) {
        // price = sales.price.replace(/\./g, '')
        // if (price === 0) {
        //   this.payment.sales.splice(salesIndex, 1)
        // } else {
        //   sales.price = parseFloat(price) + parseFloat(data.outstanding)
        // }
      } else {
        var objPrice = price === 0 ? parseFloat(data.outstanding) : parseFloat(price) - parseFloat(data.outstanding)
        obj = {
          payment_no: null,
          sale_no: data.sale_no,
          payment_date: this.payment.payment_date,
          price: objPrice,
          method_id: this.payment.method_id,
          type_id: this.payment.type_id,
          bank_id: this.payment.bank_id,
          notes: this.payment.notes,
          prepayment_date: this.payment.prepayment_date,
          group_no: this.payment.group_no,
          account_code: this.payment.account_code,
          lock: false
        }
        this.payment.sales.push(obj)
      }
      // this.payment.total = this.totalProcessPayment
    },
    async searchCustomer () {
      this.dataRaw = []
      var data = {
        customer_no: this.payment.customer_no,
        year: this.payment.payment_date,
        company_no: this.payment.company_no
      }
      this.$store.dispatch('getCustomerOutstading', data)
    },
    async searchVendor () {
      this.dataRaw = []
      var payload = {
        vendor_no: this.payment.vendor_no,
        year: this.payment.payment_date,
        company_no: this.payment.company_no
      }
      this.$store.dispatch('getVendorOutstanding', payload)
    },
    backParent () {
      this.$emit('backClicked')
    },
    setMethod () {
      var methodID = this.payment.method_id
      if (methodID === 1) {
        if (this.payment.company_no === 'C0001') {
          this.payment.account_code = '01-111-002'
        } else {
          this.payment.account_code = '11-111-002'
        }
        this.payment.prepayment_date = null
      } else if (methodID === 3) {
        if (this.payment.id == null) {
          this.payment.prepayment_date = null
          this.payment.payment_date = null
        }
      } else {
        this.payment.account_code = null
        this.payment.prepayment_date = null
      }
    },
    async print () {
      window.open(sale2Url + '/print/' + this.payment.id + '/kwitansi', '_blank')
    }
  }
}
</script>
